import type { CommunityMemberSelectVariantProps } from "./CommunityMemberSelectCompassComponent";
import { CommunityMemberSelectView } from "./CommunityMemberSelectView";
import { useCommunityMemberSelectAsyncSearch } from "./useCommunityMemberSelectAsyncSearch";

// Legacy POST-backed variant. Remove this file once
// crm_clickhouse_contacts_search_pickers_enabled is enabled for all communities.
export const CommunityMemberSelectLegacyVariant = (
  props: CommunityMemberSelectVariantProps,
) => {
  const searchState = useCommunityMemberSelectAsyncSearch({
    excludeAdmins: props.excludeAdmins,
    filters: props.filters,
    getCommunityMemberText: props.getCommunityMemberText,
    includeInactive: props.includeInactive,
    valueField: props.valueField,
  });

  return <CommunityMemberSelectView {...props} {...searchState} />;
};
